import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Epic%20panoramic%20sports%20stadium%20at%20night%20with%20dramatic%20floodlights%2C%20massive%20packed%20arena%2C%20green%20field%20in%20center%2C%20fireworks%20and%20sparks%20in%20the%20air%2C%20cinematic%20atmosphere%2C%20warm%20golden%20and%20red%20accent%20lighting%2C%20epic%20scale%2C%20professional%20sports%20broadcast%20aesthetic&width=1920&height=1080&seq=hero-sports-stadium&orientation=landscape"
        alt="米乐体育 - 全球顶级体育赛事直播平台"
        title="米乐体育 - 全球顶级体育赛事直播平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-4 leading-tight">
            全球顶级赛事
            <span className="block text-accent-500">一站尽享</span>
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
            米乐体育汇聚全球顶级赛事直播、专业数据分析与互动娱乐体验。
            即开即看，流畅稳定，随时随地感受体育的魅力。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/football"
              className="bg-primary-500 text-background-50 px-8 py-3 rounded-md text-base font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/30"
            >
              观看直播
            </Link>
            <Link
              to="/about"
              className="bg-white/10 backdrop-blur-sm text-white border border-white/30 px-8 py-3 rounded-md text-base font-medium hover:bg-white/20 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>

          <div className="mt-10 flex items-center justify-center gap-8 flex-wrap">
            {[
              { label: '5,800万+', sub: '注册用户' },
              { label: '200+', sub: '覆盖赛事' },
              { label: '50,000+', sub: '年直播场次' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-accent-500">{stat.label}</div>
                <div className="text-xs md:text-sm text-white/60 mt-1">{stat.sub}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}